import {
  addProgramAnnouncementsApi,
  archieveTeamApi,
  archiveChannelPostApi,
  getAllProgramsApi,
  getChannelPostDetails,
  getEnrollmentChannelsListApi,
  getPostListApi,
  getProgramAnnouncementsApi,
  getProgramApi,
  getProgramFormListApi,
  getProgramMyActionItemsApi,
  getProgramMyBackpackApi,
  getProgramTeamsApi,
  getProgramTeamUsersApi,
  getUploadImageUrl,
  getUserApi,
  joinChannelApi,
  leaveChannelApi,
  readPostApi,
  removeProgramAnnouncementsApi,
  saveTeamsApi,
  unArchiveChannelPostApi,
  updateFormInProgramPhase,
  updateProgramAnnouncementsApi,
} from "../../api";
import { logger, format } from "../../datadogLogger";
import { GET_ACTIVE_CHANNELS, GET_ALL_PROGRAMS, GET_ALL_PROGRAMS_ERROR, GET_ALL_PROGRAMS_LOADING, GET_CHANNEL_POST_DETAILS, GET_POST_ERROR, GET_POST_LOADING, GET_PROGRAM_ACTION_ITEMS, GET_PROGRAM_ACTION_ITEMS_ERROR, GET_PROGRAM_ACTION_ITEMS_LOADING, GET_PROGRAM_ANNOUNCEMENTS, GET_PROGRAM_ANNOUNCEMENTS_ERROR, GET_PROGRAM_ANNOUNCEMENTS_LOADING, GET_PROGRAM_BACKPACK_DATA, GET_PROGRAM_BACKPACK_DATA_ERROR, GET_PROGRAM_BACKPACK_DATA_LOADING, GET_PROGRAM_CHANNEL_POST_LIST, GET_PROGRAM_FORM_CONTEXT_USER_INFO, GET_PROGRAM_FORM_CONTEXT_USER_INFO_ERROR, GET_PROGRAM_FORM_CONTEXT_USER_INFO_LOADING, GET_PROGRAM_FORMS_LIST, GET_PROGRAM_FORMS_LIST_ERROR, GET_PROGRAM_FORMS_LIST_LOADING, GET_PROGRAM_TEAM_USERS, GET_PROGRAM_TEAM_USERS_ERROR, GET_PROGRAM_TEAM_USERS_LOADING, GET_PROGRAM_TEAMS, GET_PROGRAM_TEAMS_ERROR, GET_PROGRAM_TEAMS_LOADING, GET_SINGLE_PROGRAM, GET_SINGLE_PROGRAM_ERROR, GET_SINGLE_PROGRAM_LOADING, GET_SUBSCRIBE_CHANNELS, REMOVE_TEAM, REMOVE_TEAM_ERROR, REMOVE_TEAM_LOADING, RESET_PROGRAM_FORM_CONTEXT, SAVE_TEAM, SAVE_TEAM_ERROR, SAVE_TEAM_LOADER, SET_PROGRAM_FORM_CONTEXT, UPDATE_PROGRAM_FORM, UPDATE_PROGRAM_FORM_ERROR, UPDATE_PROGRAM_FORM_LOADING,SELECTED_POST_MENU, START_LOADING, CLOSE_LOADING } from "../../types";
import { ITeam, Announcement } from "../../types/team";
import toastr from "toastr";


export const getProgramFormList = (programId) => {
  return async (dispatch: any) => {
    dispatch(programFormLoading());

    try {
      const res: any = await getProgramFormListApi(programId);
      if (res) {
        dispatch(programFormSuccess(res.forms));
      } else {
        dispatch(programFormError(res.message || "An error occurred"));
      }
    } catch (error) {
      dispatch(programFormError(error.message || "An error occurred"));
    }
  };
};

export const getAllPrograms = () => {
  return async (dispatch: any) => {
    dispatch(getAllProgramsLoading());
    try {
      const res: any = await getAllProgramsApi();
      if (res) {
        dispatch(getAllProgramsSuccess(res));
      } else {
        dispatch(getAllProgramsError(res.message || "An error occurred"));
      }
    } catch (error) {
      dispatch(getAllProgramsError(error.message || "An error occurred"));
    }
  };
};

export const getProgramById = (programId: string) => {
  return async (dispatch: any) => {
    dispatch(getProgramLoading());
    try {
      const res: any = await getProgramApi(programId);
      if (res) {
        dispatch(getProgramSuccess(res));
      } else {
        dispatch(getProgramError(res.message || "An error occurred"));
      }
    } catch (error) {
      dispatch(getProgramError(error.message || "An error occurred"));
    }
  };
};
export const channelPostDetails = (
  programId: string,
  userId: string,
  contextId: string,
) => {
  return async (dispatch: any) => {
    dispatch(getPostLoading());
    try {
      const res: any = await getChannelPostDetails(
        programId,
        userId,
        contextId,
      );
      if (res) {
         return res
        }
    } catch (error) {
      dispatch(getPostError(error.message || "An error occurred"));
    }
  };
};

export const archiveChannelPost = (
  programId: string,
  contextId: string,
) => {
  return async (dispatch: any) => {
    dispatch(getPostLoading());
    try {
      const res: any = await archiveChannelPostApi(
        programId,
        contextId,
      );
      if (res) {
        if(res?.['_isArchived'])
        {
          toastr.success('Archived Successfully');
        }
        const {programId, userId, communityIdentifier, channelIdentifier}=res
        await dispatch(getChannelPostList(programId, userId, communityIdentifier, channelIdentifier))
      }
    } catch (error) {
      dispatch(getPostError(error.message || "An error occurred"));
    }
  };
};

export const unArchiveChannelPost = (
  programId: string,
  contextId: string,
) => {
  return async (dispatch: any) => {
    dispatch(getPostLoading());
    try {
      const res: any = await unArchiveChannelPostApi(
        programId,
        contextId,
      );
      if (res) {
        if(!res?.['_isArchived'])
          {
            toastr.success('UnArchived Successfully');
          }
          const {programId, userId, communityIdentifier, channelIdentifier}=res
          await dispatch(getChannelPostList(programId, userId, communityIdentifier, channelIdentifier))
      }
    } catch (error) {
      dispatch(getPostError(error.message || "An error occurred"));
    }
  };
};

export const getChannelPostList = (
  programId: string,
  userId: string,
  communityIdentifier: string,
  channelName: string,
  showArchived: Boolean=false
) => {
  return async (dispatch: any) => {
    dispatch(getPostLoading());
    try {
      const res: any = await getPostListApi(
        programId,
        userId,
        communityIdentifier,
        channelName,
        showArchived
      );
      if (res) {
        let postData = { [channelName]: res };


        dispatch(getProgramChannelPostList(postData));
      }
    } catch (error) {
      dispatch(getPostError(error.message || "An error occurred"));
    }
  };
};
export const getImageUrl = (
  file: File
) => {
  return async (dispatch: any) => {
    dispatch(getPostLoading());
    try {
      const res: any = await getUploadImageUrl(
        file
      );
      if (res) {
        return res.fileName
      }
    } catch (error) {
      console.log("error", error)
    }
  };
};

export const getEnrolledChannels = (
  programId: string,
  userId: string,
  communityIdentifier: string
) => {
  return async (dispatch: any) => {
    dispatch(getPostLoading());
    try {
      const res: any = await getEnrollmentChannelsListApi(
        programId,
        userId,
        communityIdentifier
      );
      if (res) {
        const enrolledUser = res.filter((item) => item.channelIdentifier)
        dispatch(getSubscribeChannels(enrolledUser));
      }
      return res
      // if (res) {
      //   let postData = { [channelName]: res };
      //   dispatch(getProgramChannelPostList(postData));
      // }
    } catch (error) {
      console.log("errror", error)
      dispatch(getPostError(error.message || "An error occurred"));
    }
  };
};
export const readChannelPost = (programId: string, userId: string, contextIds: string | string[]) => {
  return async (dispatch: any) => {
    if (!programId || !userId) return;
    const contexts = Array.isArray(contextIds) ? contextIds : [contextIds];
    if (contexts.length === 0 || contexts.some((ctx) => !ctx)) return;
    dispatch(getPostLoading());
    try {
      await readPostApi(programId, userId, contexts);
      // if(res)
      // {
      //   let postData={[channelName]:res}
      //   dispatch(getProgramChannelPostList(postData));
      // }
    } catch (error) {
      dispatch(getPostError(error.message || "An error occurred"));
    }
  };
};

export const joinChannel = (
  programId: string,
  userId: string,
  communityIdentifier: string,
  channelName: string,
  toastMessage: boolean = true
) => {
  return async (dispatch: any) => {
    // dispatch(getPostLoading());
    try {
      const res: any = await joinChannelApi(
        programId,
        userId,
        communityIdentifier,
        channelName
      );
      if (res.status === "success") {
        if (toastMessage)
          toastr.success(res.message);
        if (Array.isArray(res)) {
          let postData = { [channelName]: res };
          dispatch(getProgramChannelPostList(postData));
        }
        // IMPORTANT: Don't refresh enrollment here - let caller handle it
        // This prevents multiple concurrent getEnrolledChannels calls
        // dispatch(getEnrolledChannels(programId, userId, communityIdentifier));

      }
      return res;
    } catch (error) {
      dispatch(getPostError(error.message || "An error occurred"));
      throw error; // Re-throw so caller knows it failed
    }
  };
};

export const leaveChannel = (
  programId: string,
  userId: string,
  communityIdentifier: string,
  channelName: string,
  toastMessage: boolean = true

) => {
  return async (dispatch: any) => {
    // dispatch(getPostLoading());
    try {
      const res: any = await leaveChannelApi(
        programId,
        userId,
        communityIdentifier,
        channelName
      );
      if (res.status === "success") {
        toastMessage && toastr.success(res.message);
        if (Array.isArray(res)) {
          let postData = { [channelName]: res };
          dispatch(getProgramChannelPostList(postData));
        }
        // IMPORTANT: Don't refresh enrollment here - let caller handle it
        // This prevents multiple concurrent getEnrolledChannels calls
        // dispatch(getEnrolledChannels(programId, userId, communityIdentifier));

      }
      return res;
    } catch (error) {
      dispatch(getPostError(error.message || "An error occurred"));
      throw error; // Re-throw so caller knows it failed
    }
  };
};


export const getProgramMyBackpackData = (programId: string, userId: string) => {
  return async (dispatch: any) => {
    dispatch(getProgramBackpackLoading());
    try {
      const res: any = await getProgramMyBackpackApi(programId, userId);
      dispatch(getProgramBackpackSuccess(res?.backpack));
    } catch (error) {
      if (error?.response) {
        dispatch(
          getProgramBackpackError(
            error.response?.data?.message || "An error occurred"
          )
        );
        return;
      }
      dispatch(getProgramBackpackError(error.message || "An error occurred"));
    }
  };
};

export const getProgramActionItemsData = (
  programId: string,
  userId: string
) => {
  return async (dispatch: any) => {
    dispatch(getProgramActionItemsLoading());
    try {
      const res: any = await getProgramMyActionItemsApi(programId, userId);
      dispatch(getProgramActionItemsSuccess(res));
    } catch (error) {
      if (error?.response) {
        dispatch(
          getProgramActionItemsError(
            error.response?.data?.message || "An error occurred"
          )
        );
        return;
      }
      dispatch(
        getProgramActionItemsError(error.message || "An error occurred")
      );
    }
  };
};

export const getProgramAnnouncementData = (
  programId: string,
  userId: string
) => {
  return async (dispatch: any) => {
    dispatch(getProgramAnnouncementLoading());
    try {
      const res: any = await getProgramAnnouncementsApi(programId, userId);
      dispatch(getProgramAnnouncementSuccess(res));
    } catch (error) {
      if (error?.response) {
        dispatch(
          getProgramAnnouncementError(
            error.response?.data?.message || "An error occurred"
          )
        );
        return;
      }
      dispatch(
        getProgramAnnouncementError(error.message || "An error occurred")
      );
    }
  };
};
export const removeProgramAnnouncementData = (data: Announcement) => {
  return async (dispatch: any) => {
    dispatch(getProgramAnnouncementLoading());
    try {
      const res: any = await removeProgramAnnouncementsApi(data._id);
      if (res.success || res) {
        dispatch(getProgramAnnouncementData(data.programId, data.userId));
        toastr.success("Announcement Deleted successfully");
      }
    } catch (error) {
      if (error?.response) {
        dispatch(
          getProgramAnnouncementError(
            error.response?.data?.message || "An error occurred"
          )
        );
        return;
      }
      dispatch(
        getProgramAnnouncementError(error.message || "An error occurred")
      );
    }
  };
};

export const getProgramFormContextUserData = (userId) => {
  return async (dispatch: any) => {
    try {
      if (userId != null) {
        const res = await getUserApi(userId);
        dispatch(getProgramContextUserSuccess(res));
      } else {
        dispatch(getProgramContextUserError("No user Found"));
      }
      dispatch(getProgramContextUserLoading(false));
    } catch (error) {
      dispatch(getProgramContextUserLoading(false));
      dispatch(getProgramContextUserError(error));
    }
  };
};

export const updateFormInProgram = (programId, data) => {
  return async (dispatch) => {
    dispatch(updateProgramFormLoading());
    try {
      const res: any = await updateFormInProgramPhase(programId, data);
      if (res) {
        dispatch(updateProgramFormSuccess(res));
      } else {
        dispatch(updateProgramFormError("Update failed"));
      }
    } catch (error) {
      if (error.response) {
        dispatch(
          updateProgramFormError(
            error.response.data.message || "An error occurred"
          )
        );
      } else {
        dispatch(updateProgramFormError(error.message || "An error occurred"));
      }
    }
  };
};

export const getProgramTeams = (programId: string) => {
  return async (dispatch: any) => {
    dispatch(getProgramTeamLoading());
    try {
      const res: any = await getProgramTeamsApi(programId);
      dispatch(getProgramTeamSuccess(res));
    } catch (error) {
      if (error?.response) {
        dispatch(
          getProgramTeamError(
            error.response?.data?.message || "An error occurred"
          )
        );
        return;
      }
      dispatch(getProgramTeamError(error.message || "An error occurred"));
    }
  };
};

export const removeTeam = (teamId: string) => {
  return async (dispatch: any) => {
    dispatch(removeTeamLoading());
    try {
      const res = await archieveTeamApi(teamId);
      dispatch(removeTeamSuccess(teamId));
    } catch (error) {
      logger.error("Error removing team:", error);
      toastr.error(error?.response?.data?.message || "Failed to Archieve team");
      dispatch(removeTeamError(error.message));
    }
  };
};

export const saveTeams = (team: ITeam) => {
  return async (dispatch: any) => {
    dispatch(setSaveTeamLoading(true));

    try {
      const res = await saveTeamsApi(team);

      if (res.success) {
        dispatch(setSaveTeamSuccess(res.data));
        toastr.success("Team updated successfully");
      } else {
        dispatch(setSaveTeamError(res));
        toastr.error("Unable to update team");
      }
    } catch (error) {
      logger.error(format(`Failed to save team=${team._id}`), error);
      dispatch(setSaveTeamError(error));
      toastr.error("An error occurred while updating the profile");
    } finally {
      dispatch(setSaveTeamLoading(false));
    }
  };
};

export const saveAnnounceMent = (announcement: Announcement) => {
  return async (dispatch: any) => {
    dispatch(setSaveTeamLoading(true));
    try {
      const res = await addProgramAnnouncementsApi(announcement);
      if (res.success || res) {
        dispatch(
          getProgramAnnouncementData(
            announcement.programId,
            announcement.userId
          )
        );
        toastr.success("Team updated successfully");
      } else {
        toastr.error("Unable to update team");
      }
    } catch (error) {
      // logger.error(format(`Failed to save team=${team._id}`), error);
      toastr.error("An error occurred while updating the profile");
    } finally {
      dispatch(setSaveTeamLoading(false));
    }
  };
};

export const updateAnnounceMent = (data: Announcement) => {
  return async (dispatch: any) => {
    dispatch(setSaveTeamLoading(true));
    try {
      const res = await updateProgramAnnouncementsApi(data);
      if (res.success || res) {
        dispatch(getProgramAnnouncementData(data.programId, data.userId));
        toastr.success("Announcement updated successfully");
      } else {
        dispatch(setSaveTeamError(res));
        toastr.error("Unable to update team");
      }
    } catch (error) {
      // logger.error(format(`Failed to save team=${team._id}`), error);
      dispatch(setSaveTeamError(error));
      toastr.error("An error occurred while updating the profile");
    } finally {
      dispatch(setSaveTeamLoading(false));
    }
  };
};

export const getProgramTeamUsers = (programId: string, teamId: string) => {
  return async (dispatch: any) => {
    dispatch(getProgramTeamUserLoading());
    try {
      const res: any = await getProgramTeamUsersApi(programId, teamId);
      if (res?.success) {
        dispatch(getProgramTeamUserSuccess(res?.data));
      }
    } catch (error) {
      if (error?.response) {
        dispatch(
          getProgramTeamUserError(
            error.response?.data?.message || "An error occurred"
          )
        );
        return;
      }
      dispatch(getProgramTeamUserError(error.message || "An error occurred"));
    }
  };
};

export const getChannelActivePost = (payload) => ({
  type: GET_CHANNEL_POST_DETAILS,
  payload,
});
export const getActiveChannel = (payload) => ({
  type: GET_ACTIVE_CHANNELS,
  payload,
});

const getProgramTeamLoading = () => ({
  type: GET_PROGRAM_TEAMS_LOADING,
});

const getProgramTeamSuccess = (payload) => ({
  type: GET_PROGRAM_TEAMS,
  payload,
});

const getProgramTeamError = (error) => ({
  type: GET_PROGRAM_TEAMS_ERROR,
  payload: error,
});

const getProgramTeamUserLoading = () => ({
  type: GET_PROGRAM_TEAM_USERS_LOADING,
});

const getProgramTeamUserSuccess = (payload) => ({
  type: GET_PROGRAM_TEAM_USERS,
  payload,
});

const getProgramTeamUserError = (error) => ({
  type: GET_PROGRAM_TEAM_USERS_ERROR,
  payload: error,
});

const updateProgramFormLoading = () => ({
  type: UPDATE_PROGRAM_FORM_LOADING,
});



const updateProgramFormSuccess = (payload) => ({
  type: UPDATE_PROGRAM_FORM,
  payload,
});

const updateProgramFormError = (error) => ({
  type: UPDATE_PROGRAM_FORM_ERROR,
  payload: error,
});

const getProgramLoading = () => ({
  type: GET_SINGLE_PROGRAM_LOADING,
});
const getPostLoading = () => ({
  type: GET_POST_LOADING,
});

const getProgramError = (error: any) => ({
  type: GET_SINGLE_PROGRAM_ERROR,
  payload: error,
});

const getPostError = (error: any) => ({
  type: GET_POST_ERROR,
  payload: error,
});

const getProgramSuccess = (payload) => ({
  type: GET_SINGLE_PROGRAM,
  payload,
});

const getAllProgramsLoading = () => ({
  type: GET_ALL_PROGRAMS_LOADING,
});

const getAllProgramsSuccess = (payload) => ({
  type: GET_ALL_PROGRAMS,
  payload,
});

const getAllProgramsError = (error: any) => ({
  type: GET_ALL_PROGRAMS_ERROR,
  payload: error,
});

const getProgramContextUserLoading = (isLoading: boolean) => ({
  type: GET_PROGRAM_FORM_CONTEXT_USER_INFO_LOADING,
  payload: isLoading,
});

const getProgramContextUserSuccess = (payload) => ({
  type: GET_PROGRAM_FORM_CONTEXT_USER_INFO,
  payload,
});

const getProgramContextUserError = (error: any) => ({
  type: GET_PROGRAM_FORM_CONTEXT_USER_INFO_ERROR,
  payload: error,
});

export const setProgramFormContext = (payload) => ({
  type: SET_PROGRAM_FORM_CONTEXT,
  payload,
});

export const resetProgramFormContext = () => ({
  type: RESET_PROGRAM_FORM_CONTEXT,
});

const getProgramAnnouncementLoading = () => ({
  type: GET_PROGRAM_ANNOUNCEMENTS_LOADING,
});

const getProgramAnnouncementSuccess = (payload) => ({
  type: GET_PROGRAM_ANNOUNCEMENTS,
  payload,
});

const getProgramAnnouncementError = (error: any) => ({
  type: GET_PROGRAM_ANNOUNCEMENTS_ERROR,
  payload: error,
});

const getProgramActionItemsLoading = () => ({
  type: GET_PROGRAM_ACTION_ITEMS_LOADING,
});

const getProgramActionItemsSuccess = (payload) => ({
  type: GET_PROGRAM_ACTION_ITEMS,
  payload,
});

const getProgramActionItemsError = (error: any) => ({
  type: GET_PROGRAM_ACTION_ITEMS_ERROR,
  payload: error,
});

const getProgramBackpackLoading = () => ({
  type: GET_PROGRAM_BACKPACK_DATA_LOADING,
});

const getProgramBackpackSuccess = (payload) => ({
  type: GET_PROGRAM_BACKPACK_DATA,
  payload,
});

const getProgramBackpackError = (error: any) => ({
  type: GET_PROGRAM_BACKPACK_DATA_ERROR,
  payload: error,
});

const programFormLoading = () => ({
  type: GET_PROGRAM_FORMS_LIST_LOADING,
});

const programFormSuccess = (payload) => ({
  type: GET_PROGRAM_FORMS_LIST,
  payload,
});

const programFormError = (error: any) => ({
  type: GET_PROGRAM_FORMS_LIST_ERROR,
  payload: error,
});

const setSaveTeamLoading = (isLoading: boolean) => ({
  type: SAVE_TEAM_LOADER,
  payload: isLoading,
});

const setSaveTeamSuccess = (data: any) => ({
  type: SAVE_TEAM,
  payload: data,
});

const setSaveTeamError = (error: any) => ({
  type: SAVE_TEAM_ERROR,
  payload: error,
});

export const getProgramChannelPostList = (payload) => ({
  type: GET_PROGRAM_CHANNEL_POST_LIST,
  payload,
});

const getSubscribeChannels = (payload) => ({
  type: GET_SUBSCRIBE_CHANNELS,
  payload,
})

export const setSelectedPostMenu = (payload) => ({
  type: SELECTED_POST_MENU,
  payload,
})


export const removeTeamLoading = () => ({ type: REMOVE_TEAM_LOADING });
export const removeTeamSuccess = (teamId: string) => ({
  type: REMOVE_TEAM,
  payload: teamId,
});
export const removeTeamError = (error: string) => ({
  type: REMOVE_TEAM_ERROR,
  payload: error,
});
